import PubSub from "pubsub-js";
import * as util from "lib/util.js";
import { Router } from '@vaadin/router';
import { storeInstance } from "store";

export const httpError = (response) => {
  let contentType = response.headers.get("content-type");
  errorObj.status = response.status;
  switch (contentType) {
    case responseType.html:
      handleHTMLResponse(response);
      break;
    case responseType.json:
      handleJSONResponse(response);
      break;
  }
};

const handleJSONResponse = async (response) => {
  let error = await response.json();
  errorObj.shortDesc = error.shortDesc;
  errorObj.detail = error.longDesc;
  switch (true) {
    case response.status >= 500:
      util.log(error.longDesc);
      PubSub.publish("error.serverError", errorObj);
      break;
    case response.status === 401:
      if (storeInstance.state?.kb_user?.username) {
        storeInstance.dispatch("logout");
      }
      break;
    case response.status === 403:
      handleForbidden();
      PubSub.publish("error.forbidden", errorObj);
      break;
    case response.status === 404:
      util.log(error);
      PubSub.publish("error.notfound", errorObj);
      break;
    case response.status === 409:
      util.log(error);
      storeInstance.dispatch("showNotification", {
        type: "error",
        message: error.shortDesc,
      });
      break;
  }
};

const handleHTMLResponse = async (response) => {
  let htmlText = await response.text();
  errorObj.shortDesc = "An error occurred.";
  errorObj.detail = htmlText;
  switch (true) {
    case response.status >= 500:
      util.log(htmlText);
      PubSub.publish("error.serverError", errorObj);
      break;
    case response.status === 401:
      storeInstance.dispatch("logout");
      break;
    case response.status === 403:
      handleForbidden();
      PubSub.publish("error.forbidden", errorObj);
      break;
    case response.status === 404:
      util.log(htmlText);
      PubSub.publish("error.notfound", errorObj);
      break;
    case response.status === 409:
      util.log(htmlText);
      PubSub.publish("error.notfound", errorObj);
      break;
    default:
      PubSub.publish("error.others", errorObj);
  }
};

let responseType = {
  html: "text/html;charset=utf-8",
  json: "application/json",
};

let errorObj = {};

let handleForbidden = () => {
  let langCode = storeInstance.state.langCode;
  Router.go(`/kb/${langCode}`);
  PubSub.publish("notifyUser", {
    messageType: "Negative",
    message: storeInstance.state[storeInstance.state.langCode]["_forbidden"],
    duration: 5,
  });
};

// const httpError2 = function (response) {
//   console.log(response.headers.get)
//   errorObj.status = response.status

//   if (response.status >= 500) {
//     if (isSilent) {
//       response.text().then((text) => console.log(text))
//     } else {
//       return response.json().then((error) => {
//         console.log(error)
//         util.log(error.longDesc) //might be json text
//         console.log("ERROR", errorObj)
//         errorObj.detail = error.shortDesc
//         PubSub.publish("error.serverError", errorObj)
//       })
//     }
//   } else {
//     if (response.status >= 400) {
//       switch (response.status) {
//         case 401:
//           storeInstance.dispatch("logout")
//           break
//         case 403:
//           return response.text().then((text) => {
//             util.log(text)
//             errorObj.detail = text
//             PubSub.publish("error.forbidden", errorObj)
//           })
//         case 404:
//           return response.text().then((text) => {
//             util.log(text)
//             errorObj.detail = text
//             PubSub.publish("error.notfound", errorObj)
//           })
//         case 409:
//           response.json().then((error) => {
//             errorObj.detail = error.shortDesc
//             storeInstance.dispatch("showNotification", { type: "error", message: error.shortDesc })
//           })
//           break
//         default:
//           errorObj.detail = text
//           PubSub.publish("error.other", errorObj)
//       }
//     }
//   }
// }
